import React from 'react';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import { MyContext } from '../../InitialSetup/MyProvider';
import { Utilities, _Map, _debounce, _filter } from '../../Utilities/Utilities';
import { Helmet } from "react-helmet";
import { getPredictionHistory, getTranscationHistory } from '../../WSHelper/WSCallings';
import * as WSC from "../../WSHelper/WSConstants";
import Images from '../../components/images';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomHeader from '../../components/CustomHeader';
import MetaData from "../../helper/MetaData";
import * as AppLabels from "../../helper/AppLabels";
import { TransactionList, NoDataView } from "../CustomComponent";
import { OnlyCoinsFlow } from '../../helper/Constants';

var hasMore = false;
var hasMorePredictions = true;
var transactionData = {};
export default class Transaction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionHistoryList: [],
            predictionHistory: [],
            isLoaderShow: false,
            offset: 1,
            pageSize: 20,
            current_page: 0,
            items_perpage: 20,
            isPredictionTab: false,
            ShimmerList: [1, 2, 3, 4, 5],
            activeTab: '',
            isFromNotification: (this.props.location && this.props.location.state) ? (this.props.location.state.from == 'notification' ? true : false) : false,
            navList: [
                {
                    'lb': AppLabels.ALL,
                    'src': '',
                    'bns': '',
                    'coin': ''
                },
                {
                    'lb': AppLabels.WINNINGS,
                    'src': '3',
                    'bns': '',
                    'coin': ''
                },
                {
                    'lb': AppLabels.DEPOSIT,
                    'src': '7',
                    'bns': '',
                    'coin': ''
                },
                {
                    'lb': AppLabels.WITHDRAW,
                    'src': '8',
                    'bns': '',
                    'coin': ''
                },
                {
                    'lb': AppLabels.BONUS,
                    'src': '',
                    'bns': '1',
                    'coin': ''
                }
            ]
        }
    }

    UNSAFE_componentWillMount() {
        var tmpArray = this.state.navList;
        if (Utilities.getMasterData().a_coin == "1") {
            tmpArray = [
                ...tmpArray, ...[{
                    'lb': AppLabels.COINS,
                    'src': '',
                    'bns': '',
                    'coin': '1'
                }]
            ]
        }
        if (OnlyCoinsFlow == 1 || OnlyCoinsFlow == 2) {
            tmpArray = _filter(tmpArray, (obj) => {
                return obj.lb != AppLabels.WITHDRAW && obj.lb != AppLabels.DEPOSIT
            });
        }
        if (OnlyCoinsFlow == 1) {
            tmpArray = _filter(tmpArray, (obj) => {
                return obj.lb != AppLabels.BONUS
            });
        }
        this.setState({
            navList: tmpArray
        })

        Utilities.scrollToTop()
        this.setLocationStateData()
    }

    componentWillUnmount() {
        transactionData = {}
        if (this.state.isFromNotification) {
            this.callTransactionHistoryApi('', '', '')

        }
    }

    scrollToBottom = () => {
        let elm = document.getElementsByClassName("active");
        if (elm.length > 0 && elm[0].localName === "li") {
            elm[0].scrollIntoView();
        }
    }

    setLocationStateData = () => {
        if (this.props.location && this.props.location.state) {
            this.setState({ activeTab: this.props.location.state.tab || AppLabels.ALL }, () => {
                if (this.state.activeTab === AppLabels.COINS) {
                    this.callTransactionHistoryApi('', '', 1);
                    this.scrollToBottom();
                } else {
                    this.callTransactionHistoryApi('', '', '')
                }
            });
        }
    }

    onTabChange = _debounce((item) => {
        this.setState({ offset: 1, activeTab: item.lb }, () => {
            this.callTransactionHistoryApi(item.src, item.bns, item.coin)
        })
    }, 300)


    callTransactionHistoryApi(source, onlyBonus, onlyCoins) {
        let dataKey = source + onlyBonus + onlyCoins + this.state.offset + this.state.activeTab;
        if (transactionData[dataKey]) {
            this.parseResponseData(transactionData[dataKey]);
        }
        else {
            let param = {
                "page_no": this.state.offset,
                "page_size": this.state.pageSize,
                "only_bonus": onlyBonus,
                "only_coins": onlyCoins,
                "source": source
            }

            this.setState({ isLoaderShow: true })
            getTranscationHistory(param).then((responseJson) => {
                this.setState({
                    isLoaderShow: false
                })
                if (responseJson.response_code == WSC.successCode) {
                    transactionData[dataKey] = responseJson.data;
                    this.parseResponseData(responseJson.data);
                }
            })
        }
    }

    parseResponseData(data) {
        hasMore = data.length === this.state.pageSize;
        if (this.state.offset === 1) {
            this.setState({
                offset: this.state.offset + 1,
                transactionHistoryList: data
            })
        }
        else {
            this.setState({
                offset: this.state.offset + 1,
                transactionHistoryList: [...this.state.transactionHistoryList, ...data]
            });
        }
    }

    fetchMoreData = (item) => {
        if (this.state.activeTab === item.lb) {
            this.callTransactionHistoryApi(item.src, item.bns, item.coin)
        }
    }
    fetchMorePredictionData = () => {
        if (this.state.isPredictionTab) {
            this.callPredictionHistoryApi()
        }
    }

    callPredictionHistoryApi = () => {
        const { current_page, items_perpage, predictionHistory } = this.state;
        if (hasMorePredictions) {
            this.setState({ isLoaderShow: true })
            let param = {
                current_page: current_page + 1,
                items_perpage
            }

            getPredictionHistory(param).then((responseJson) => {
                this.setState({
                    isLoaderShow: false
                })
                if (responseJson.response_code == WSC.successCode) {
                    if (!responseJson.data || responseJson.data.length < items_perpage) {
                        hasMorePredictions = false;
                    }
                    let temp = responseJson.data ? responseJson.data : []
                    this.setState({
                        predictionHistory: [...predictionHistory, ...temp],
                        current_page:current_page + 1,
                    })
                }
            })
        }
    }

    onTypeChange = (isPrediction) => {
        hasMorePredictions = true;
        this.setState({
            isPredictionTab: isPrediction,
            predictionHistory: [],
            current_page: 0
        }, () => {
            this.fetchMorePredictionData()
            console.log(this.state, 'onTypeChange');
        })
    }

    render() {

        const HeaderOption = {
            back: true,
            title: AppLabels.TRANSACTIONS,
            hideShadow: true,
        }

        const { transactionHistoryList, isPredictionTab, predictionHistory } = this.state;

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container web-container-fixed trans-web-container">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.transactions.title}</title>
                            <meta name="description" content={MetaData.transactions.description} />
                            <meta name="keywords" content={MetaData.transactions.keywords}></meta>
                        </Helmet>
                        <CustomHeader {...this.props} HeaderOption={HeaderOption} />
                        <div style={{
                            display: "flex",

                            justifyContent: "center",
                            background: "white",
                            color: "#23416a",
                            cursor: 'pointer',
                            borderBottom:"1px solid #F2F2F2"
                        }}>
                            <div style={{
                                flex: 1,
                                padding: "10px",
                                display: "flex",
                                justifyContent: "center",
                                textAlign: "center",
                                borderBottom: !isPredictionTab ? "2px solid #23416a" : "transparent"
                            }}
                                onClick={() => this.onTypeChange(false)}
                            >Fantasy</div>
                            <div style={{
                                flex: 1,
                                padding: "10px",
                                display: "flex",
                                justifyContent: "center",
                                textAlign: "center",
                                borderBottom: isPredictionTab ? '2px solid #23416a' : "transparent"
                            }}
                                onClick={() => this.onTypeChange(true)}
                            >Prediction</div>
                        </div>
                        {isPredictionTab ? <InfiniteScroll
                            dataLength={predictionHistory.length}
                            next={() => this.fetchMorePredictionData()}
                            hasMore={hasMorePredictions}
                            scrollableTarget='trans-list'
                        >
                            {predictionHistory != '' ?
                                <TransactionList transactionHistoryList={predictionHistory} selectedTAB={''} id="trans-list" />
                                :
                                <NoDataView
                                    BG_IMAGE={Images.no_data_bg_image}
                                    CENTER_IMAGE={Images.BRAND_LOGO_FULL}
                                    MESSAGE_1={'No Transactions available'}
                                    MESSAGE_2={''}
                                />
                            }
                        </InfiniteScroll> : <Tab.Container id="tabs-with-dropdown" defaultActiveKey={this.state.activeTab} className="default-tab">
                            <Row className="clearfix">
                                <Col sm={12}>
                                    <Nav bsStyle="tabs">
                                        {
                                            _Map(this.state.navList, (item, key) => {
                                                return <NavItem eventKey={item.lb} onClick={() => this.onTabChange(item)} key={key} id={item.lb}>{item.lb}</NavItem>

                                            })
                                        }
                                    </Nav>
                                </Col>
                                <Col sm={12}>
                                    <Tab.Content animation>
                                        {
                                            _Map(this.state.navList, (item, key) => {
                                                return (
                                                    <Tab.Pane eventKey={item.lb} key={key + item.lb}>
                                                        <InfiniteScroll
                                                            dataLength={transactionHistoryList.length}
                                                            next={() => this.fetchMoreData(item)}
                                                            hasMore={hasMore}
                                                            scrollableTarget='trans-list'
                                                        >
                                                            {transactionHistoryList != '' ?
                                                                <TransactionList transactionHistoryList={transactionHistoryList} selectedTAB={this.state.activeTab} id="trans-list" />
                                                                :
                                                                <NoDataView
                                                                    BG_IMAGE={Images.no_data_bg_image}
                                                                    CENTER_IMAGE={Images.BRAND_LOGO_FULL}
                                                                    MESSAGE_1={'No Transactions available'}
                                                                    MESSAGE_2={''}
                                                                />
                                                            }
                                                        </InfiniteScroll>
                                                    </Tab.Pane>
                                                )
                                            })

                                        }
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>}
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}